module.exports = __webpack_public_path__ + "static/media/notice-icon.6e38eeff.svg";